<template>
    <div style="width:100%">
        <div id="lineDiagram"></div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            timer:null,
            tagTrue:0,
            // sjcb:[],
            // jhjz:[],
            // zz:[],
            // sjcbValue:[820, 932, 901, 934, 1290, 1330, 1320],
            // jhjzValue:[333, 666, 777, 934, 1290, 1330, 1320],
            // zzValue:[66, 666, 56, 67, 90, 99, 66],

            sjcb:[820, 932, 901, 934, 1290, 1330, 1320],
            jhjz:[333, 666, 777, 934, 1290, 1330, 1320],
            zz:[66, 666, 56, 67, 90, 99, 66],
            // tagLength:0

        }
    },
    mounted(){
        this.getEchartDiagram()
        // this.timer = setInterval(this.echartMove, 300);

    },
    methods:{
        echartMove(){
      setTimeout(() => {
          console.log("多久44444",this.tagTrue)
          if(this.tagLength<this.sjcbValue.length){
              this.sjcb.push(this.sjcbValue[this.tagLength])
              this.jhjz.push(this.jhjzValue[this.tagLength])
              this.zz.push(this.zzValue[this.tagLength])
              this.tagLength+=1
          }else{
              this.tagLength=0
                this.sjcb=[]
                this.jhjz=[]
                this.zz=[]
          }
          this.getEchartDiagram()
      }, 10000);
        },
        getEchartDiagram(){
        let that = this;
        var myChart = that.$echarts.init(document.getElementById('lineDiagram'));
        let option={
              grid: {
                bottom: "8%"
            },
                color:['rgb(58,203,255)','rgb(22,190,78)','rgb(246,143,50)'],
                    legend: {
                    data: ['实际成本(AC)', '计划价值(PV)', '挣值(EV)'],
                    textStyle: {
						fontSize: 12,
						color: "#fff",
						fontWeight: "normal",
					},
                },
                xAxis: {
                    type: 'category',
                    data: ['1', '2', '3', '4', '5', '6', '7'],
                    boundaryGap: false, // 不留白，从原点开始
                    axisLabel:{
                        textStyle:{
                            color:'#fff',
                            fontSize:12
                        },
                        lineStyle:{
                            color:'#000'
                        }
                    },
                axisPointer: {
                    value: '5',
                    snap: true,
                    lineStyle: {
                        type:'slid',
                        color: '#fff',
                        width: 1
                    },
                    label: {
                        show: true,
                        formatter: function (params) {
                        return '今天';
                        },
                        backgroundColor: '#7581BD'
                    },
                    handle: {
                        show: true,
                        color: '#7581BD',
                        icon: "circle",
                        size:[20,20]
                    }
                    },
                },
				yAxis: {
                    name:'累计值(万元)',
					type: "value",
					// name: "单位(组)",
                    nameTextStyle: {
                        color: "#fff"
                        },
					axisLabel: {
						show: true,
						// formatter: "{value}",
                        textStyle:{
                            color:'#fff',
                            fontSize:12
                        }
					},
                           splitLine: {
                        show:true,
                        lineStyle: {
                            color: "#575757"
                        }
                        },
                    axisLine:{
                        lineStyle:{
                            color:'#333'
                        }
                    },
				},
                series: [
                    {
                    name:'实际成本(AC)',
                    data: this.sjcb,
                    type: 'line',
                    symbol: "none",
                    smooth: true,
                        animationDuration: 3000,
                    animation: true,
                    itemStyle: {
                            normal: {
                                lineStyle: {
                                width:3// 0.1的线条是非常细的了
                                }
                            }
                        },
                    },
                    {
                    name:'计划价值(PV)',
                    data: this.jhjz,
                    type: 'line',
                    symbol: "none",
                    smooth: true,
                        animationDuration: 3000,
                    animation: true,
                    itemStyle: {
                            normal: {
                                lineStyle: {
                                width:3// 0.1的线条是非常细的了
                                }
                            }
                        },
                    },
                    {
                    name:'挣值(EV)',
                    data: this.zz,
                    type: 'line',
                    symbol: "none",
                    smooth: true,
                        animationDuration: 3000,
                    animation: true,
                    itemStyle: {
                            normal: {
                                lineStyle: {
                                width:3// 0.1的线条是非常细的了
                                }
                            }
                        },
                    },
                ]
                };
        option && myChart.setOption(option);
        window.onresize = function(){
            myChart.resize();
        }
        }

    }
}
</script>
<style lang="less" scoped>
#lineDiagram{
    width: 100%;
    height: 230px;
}
</style>


// WEBPACK FOOTER //
// src/components/cockpitCh/echarts/echartDiagram.vue